import { buildProps } from '@sgui-plus/utils/props'
import { modalEmits, modalProps } from '@sgui-plus/components/modal'
import type { ExtractPropTypes } from 'vue'

export const drawerProps = buildProps({
  ...modalProps,
  direction: {
    type: String,
    default: 'rtl',
    values: ['ltr', 'rtl', 'ttb', 'btt'],
  },
  size: {
    type: [String, Number],
    default: '30%',
  },
  withHeader: {
    type: Boolean,
    default: true,
  },
  modalFade: {
    type: Boolean,
    default: true,
  },
  maximize: {
    type: Boolean,
    default: false,
  }
} as const)

export type DrawerProps = ExtractPropTypes<typeof drawerProps>

export const drawerEmits = modalEmits
